<h1 mat-dialog-title>Assign Observation Group ({{ group.name }}) to Vehicle Groups</h1>

<form #form="ngForm">
	<mat-dialog-content>
		@if (isLoading) {
			<mat-progress-spinner mode="indeterminate" diameter="30" class="mx-a"></mat-progress-spinner>
		} @else {
			<div class="flex-column">
				@for (group of vehicleGroups; track group.id) {
					<mat-checkbox [(ngModel)]="selectedVehicleCategoryIds[group.id]"
								  [name]="'G' + group.id">
						{{ group.name }}
					</mat-checkbox>
				}
			</div>
		}
		@if (isSaving) {
			<mat-progress-bar mode="indeterminate"></mat-progress-bar>
		}
	</mat-dialog-content>
	<mat-dialog-actions>
		<button mat-stroked-button mat-dialog-close>
			Cancel
		</button>
		<button mat-flat-button
				type="submit"
				(click)="assignGroups()"
				[disabled]="form.invalid">
			Assign
		</button>
	</mat-dialog-actions>
</form>
